import useSWR from 'swr'
import { parseEther, Address } from 'viem'
import { useLidoSDK } from './useLidoSDK'
import { useDebounce } from '~/hooks'
import { useAccount } from 'wagmi'
import { WithdrawToken } from '../Withdrawal/types'

export const useWithdrawalAllowanceInfo = (
  amount: string,
  token: WithdrawToken,
) => {
  const { address: account } = useAccount()
  const { withdraw } = useLidoSDK()
  const debouncedAmount = useDebounce(amount, 500)
  const formattedAmount = parseEther(debouncedAmount)

  const { data } = useSWR(
    account
      ? [
          'lido-withdrawal-allowance',
          formattedAmount.toString(),
          token,
          account,
        ]
      : null,
    () =>
      withdraw.approval.checkAllowance({
        amount: formattedAmount,
        account: account as Address,
        token,
      }),
    {
      refreshInterval: 60000,
    },
  )

  return {
    allowance: data?.allowance,
    needsApprove: data?.needsApprove,
  }
}
